import * as Yup from 'yup';

export type SelectedPerson = {
  id: string;
  name: string | null;
  avatar_id: string | null;
  color: string | null;
};

export type ChatCreateGroupFormValues = {
  searchTerm: string;
  people: SelectedPerson[];
  title: string;
  color: string | null;
  avatarId: string | null;
  localAvatarUrl: string | null;
  isInfoStep: boolean;
};

export const SelectedPersonSchema: Yup.ObjectSchema<SelectedPerson> =
  Yup.object({
    id: Yup.string().required(),
    name: Yup.string().nullable().defined(),
    avatar_id: Yup.string().nullable().defined(),
    color: Yup.string().nullable().defined(),
  }).defined();
